import { Box, Center, Flex, Heading, Spinner, Text } from '@chakra-ui/react'
// import { Button } from 'uikit'
import { Logo } from 'features/Logo'

export const Auth = ({ loading }) => {
  // const onSSOAuth = async () => {
  //   window.location.href = '/oauth2/start?rd=/'
  // }

  return (
    <Center
      boxSize="100%"
      display="flex"
      flexDirection="column"
      alignContent="center"
      alignItems="center"
      backgroundColor="gray50"
    >
      <Box width="370px" backgroundColor="gray100" p="40px" borderRadius={8} borderWidth="1px">
        <Flex flexDirection="column" alignItems="center" textAlign="center">
          <Logo boxSize="120px" mb={6} />
          <Heading as="h3" size="md" mb={2}>
            IDpay Admin
          </Heading>
          <Text fontSize="0.9rem">Авторизация</Text>
          {loading && <Spinner color="blue.500" size="md" mt={8} />}
          {/* {!loading && (
            TODO: Разобраться с SSO ручным входом если такой есть
            <Button mt={8} colorPalette="orange" onClick={() => onSSOAuth()} disabled={loading}>
              С помощью SSO
            </Button>
          )} */}
          <Box mt={8} color="gray.400" fontSize="xs" style={{ textAlign: 'center' }}>
            27.05.26
          </Box>
        </Flex>
      </Box>
    </Center>
  )
}
